// src/app/features/auth/reducers/filter.reducer.ts
import { createReducer, on } from '@ngrx/store';
import {
  IFilter,
  IFilterListFilter,
  IFilterListSort,
  IFilterName,
} from '../../models/filter.model';
import { FilterActions } from './filter.actions';
import { AuthActions } from '../auth/auth.actions';

export interface FilterState {
  currentFilter: IFilter | null; // Allow both IFilter and null
  selectFilter: IFilter | null; // Allow both IFilter and null
  customFilters: IFilter[];
  total: number;
  page: number;
  limit: number;
  loading: boolean;
  error: string | null;
  filter: IFilterListFilter;
  sort: IFilterListSort;
  activeTab: number;
  allStatusFilterNames?: IFilterName[];
   allFilterNames?: {  // Change this to match API structure
    data: {
      filters: IFilterName[];
    };
    message: string;
    status: boolean;
  };

}

export const initialFilterState: FilterState = {
  currentFilter: null,
  customFilters: [],
  total: 0,
  page: 1,
  limit: 10,
  loading: false,
  error: null,
  filter: {
    filter_name: '',
    filter_type: 'Mandatory',
    input_type: 'Textbox',
    character_limit: 0
  },
  sort: {
    key: 'createdAt',
    order: 'desc',
  },
  selectFilter: null, // Initialize editFilter to nulls
  activeTab: 2, // Initialize activeTab to 0
};

// Helper function to update state
function updateState(
  state: FilterState,
  changes: Partial<FilterState>
): FilterState {
  return { ...state, ...changes };
}

export const filterReducer = createReducer(
  initialFilterState,
  // Load Filters
  on(FilterActions.loadFiltersList, (state) =>
    updateState(state, { loading: true, error: null })
  ),
  on(FilterActions.loadFiltersListSuccess, (state, { response, filterData }) =>
    updateState(state, {
      customFilters: response.data.dataFilters.list.map((filter: IFilter) => ({
        ...filter,
      })),
      total: response.data.dataFilters.total,
      page: response.data.dataFilters.page,
      limit: response.data.dataFilters.limit,
      filter: filterData?.body?.filter ?? {},
      sort: filterData?.body?.sort ?? { key: 'createdAt', order: 'desc' },
      // selectFilter: null, // Reset selectFilter on new load and handle sidebar prevent other options as well
      loading: false,
      error: null,
    })
  ),
  on(FilterActions.loadFiltersListFailure, (state, { error }) =>
    updateState(state, { loading: false, error })
  ),

  // For single filter
  on(FilterActions.loadSingleFilter, (state) =>
    updateState(state, { loading: true, error: null })
  ),
  on(FilterActions.loadSingleFilterSuccess, (state, { filter }) =>
    updateState(state, { currentFilter: filter, loading: false, error: null })
  ),
  on(FilterActions.loadSingleFilterFailure, (state, { error }) =>
    updateState(state, { loading: false, error })
  ),

  // For select filter
  on(FilterActions.selectFilter, (state) =>
    updateState(state, { loading: true, error: null })
  ),
  on(FilterActions.selectFilterSuccess, (state, { filter }) =>
    updateState(state, { selectFilter: filter, loading: false, error: null })
  ),
  on(FilterActions.selectFilterFailure, (state, { error }) =>
    updateState(state, { loading: false, error })
  ),

  // update status
  on(FilterActions.changeFilterStatus, (state) =>
    updateState(state, { loading: true, error: null })
  ),
  on(FilterActions.changeFilterStatusSuccess, (state) =>
    updateState(state, { loading: false, error: null })
  ),
  on(FilterActions.changeFilterStatusFailure, (state, { error }) =>
    updateState(state, { loading: false, error })
  ),

  // Create Filter
  on(FilterActions.createFilter, (state) =>
    updateState(state, { loading: true, error: null })
  ),
  on(FilterActions.createFilterSuccess, (state, { filter }) =>
    updateState(state, {
      customFilters: [...state.customFilters, { ...filter, _id: filter._id }],
      total: state.total + 1,
      loading: false,
      error: null,
    })
  ),
  on(FilterActions.createFilterFailure, (state, { error }) =>
    updateState(state, { loading: false, error })
  ),

  // Update Filter
  on(FilterActions.updateFilter, (state) =>
    updateState(state, { loading: true, error: null })
  ),
  on(FilterActions.updateFilterSuccess, (state) =>
    updateState(state, {
      loading: false,
      error: null,
    })
  ),
  on(FilterActions.updateFilterFailure, (state, { error }) =>
    updateState(state, { loading: false, error })
  ),

  // Delete Filter
  on(FilterActions.deleteFilter, (state) =>
    updateState(state, { loading: true, error: null })
  ),
  on(FilterActions.deleteFilterSuccess, (state) =>
    updateState(state, {
      total: state.total - 1,
      loading: false,
      error: null,
    })
  ),
  on(FilterActions.deleteFilterFailure, (state, { error }) =>
    updateState(state, { loading: false, error })
  ),

  // Set Filter Query Params
  on(FilterActions.setFilterQueryParams, (state, { params, body }) =>
    updateState(state, {
      page: params?.page ?? state.page,
      limit: params?.limit ?? state.limit,
      filter: body?.filter ? ({ ...body.filter } as IFilterListFilter) : {},
      sort: body?.sort
        ? ({ ...body.sort } as IFilterListSort)
        : { key: 'createdAt', order: 'desc' },
    })
  ),

  // Clear Current Filter
  on(FilterActions.clearCurrentFilter, (state) =>
    updateState(state, { currentFilter: null })
  ),

  // Clear Select Filter
  on(FilterActions.clearSelectedFilter, (state) =>
    updateState(state, { selectFilter: null })
  ),
  on(FilterActions.setActiveTab, (state, { tab }) =>
    ({ ...state, activeTab: tab })
  ),
  on(AuthActions.logout, () => initialFilterState),
 on(FilterActions.loadFilterNamesSuccess, (state, { response }) => {
  console.log("response::", response)
  return {
    ...state,
    allFilterNames: response,
    loading: false,
    error: null
  };
}),
);
